import React from 'react';
import "./Body.scss";
import image from "../../images/image7.jpg";
import send from "../../images/Mobi.png";
import Etu from "../../images/Etu.png";
import Banc from "../../images/Banc.png";

const Body = () => {
    return (
        <>
            <div className="body">
                <div className="carreblanc">
                StudentBank te fournie une carte bancaire
gratuite et sans frais, partout dans le monde.
Inscris toi pour avoir accès à des milliers de
tips, conseils et astuces pour négocier le fameux virage de la vie estudiantine. Nos
équipes te soutiendront pour tes projets
Bancaires, Etudes, Logements et Mobilité...
                    
                </div>
                <div className="grsend">
                     <img src={send} alt="image"  />
                     <img src={Etu} alt="image"  />
                     <img src={Banc} alt="image"  />
                </div>
               
                <h3>STUDENT BANK CA BUUUUNK!</h3>
                <img src={image} alt="image" />
            </div>
        </>
    )
}

export default Body
